<template>
    <date-picker
      v-model="date"
      type="date"
      class="date"
      value-type="YYYY-MM-DD"
      format="MMM DD YYYY"
      :placeholder="placeholder()"
      :disabled-date="disabledDates"
      editable
      @change="setDates"
    >
      <!-- <template #icon-calendar>
        <v-icon>mdi-calendar</v-icon>
      </template> -->

      <template #icon-clear>
        <v-icon>mdi-close</v-icon>
      </template>
    </date-picker>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
  components: {
    DatePicker
  },

  props: ['type'],

  data () {
    return {
      date: null,
      today: new Date().toISOString().substr(0, 10)
    }
  },

  methods: {
    placeholder () {
      switch (this.type) {
        case 'Arrival Date':
          return 'Return Date'
        case 'hotel':
          return 'CheckIn - CheckOut'
        default:
          return this.type
      }
    },

    disabledDates (date) {
      const minDate = new Date(this.today)
      minDate.setHours(0, 0, 0, 0)

      // Return Date
      if (this.type === 'Arrival Date') {
        const departure = this.$store.state.flightDates.departureDates[0]

        if (!departure) {
          return true
        }

        const departureDate = new Date(departure)
        departureDate.setHours(0, 0, 0, 0)

        return date <= departureDate
      }

      // Default
      return date < minDate
    },

    setDates (value) {
      switch (this.type) {
        case 'Departure Date':
          this.$store.dispatch('setDates', {
            data: value,
            type: 'departure1'
          })
          break

        case 'Arrival Date':
          this.$store.dispatch('setDates', {
            data: value,
            type: 'arrival'
          })
          break

        case 'Second Departure Date':
          this.$store.dispatch('setDates', {
            data: value,
            type: 'departure2'
          })
          break

        case 'Third Departure Date':
          this.$store.dispatch('setDates', {
            data: value,
            type: 'departure3'
          })
          break

        case 'Pickup Date':
          this.$store.dispatch('setDates', {
            data: value,
            type: 'pickup'
          })
          break

        case 'Drop Date':
          this.$store.dispatch('setDates', {
            data: value,
            type: 'drop'
          })
          break

        default:
          break
      }
    },

    afterTomorrow (days) {
      const date = new Date(this.today)
      date.setDate(date.getDate() + days)
      return date
    }
  },

  created () {
    if (this.$route.path !== '/') {
      switch (this.type) {
        case 'Departure Date':
          this.date = this.$store.state.flightDates.departureDates[0]
            ? this.$store.state.flightDates.departureDates[0]
            : null
          break

        case 'Arrival Date':
          this.date = this.$store.state.flightDates.arrivalDate
            ? this.$store.state.flightDates.arrivalDate
            : null
          break

        case 'Second Departure Date':
          this.date = this.$store.state.flightDates.departureDates[1]
            ? this.$store.state.flightDates.departureDates[1]
            : null
          break

        case 'Third Departure Date':
          this.date = this.$store.state.flightDates.departureDates[2]
            ? this.$store.state.flightDates.departureDates[2]
            : null
          break

        case 'Pickup Date':
          this.date = this.$store.state.carInfo.pickup
            ? this.$store.state.carInfo.pickup
            : null
          break

        case 'Drop Date':
          this.date = this.$store.state.carInfo.drop
            ? this.$store.state.carInfo.drop
            : null
          break
      }
    }
  }
}
</script>

<style>

input.mx-input{
  margin-top: 5px;
  height: 55px !important;
    width: 100% !important;
    border-radius: 5px;
    /* border: 1px solid black !important; */
 }
 div.date.mx-datepicker{
  width: 99% !important;
 }
</style>
